module.exports = __webpack_public_path__ + "static/media/github-alt.d22ee372.png";